import { DeclarationKind } from '../../core/entity/declaration.types';

/** Which list a rendered section shows. The account list has its own surface. */
export type DeclarationListKind = Extract<DeclarationKind, 'FUNDER' | 'RELATED_PARTY' | 'DIRECTOR'>;

export interface ListSpec {
  kind: DeclarationListKind;
  title: string;
  /** Why we're asking — plain English, no rule identifiers on a client screen. */
  lead: string;
  addLabel: string;
  emptyText: string;
}

/**
 * The three declared lists, as one table.
 *
 * Extracted from the panel so the panel and the add/correct dialog read the
 * same definitions — the dialog's titles are derived from these kinds, and two
 * copies is how the button and the modal it opens start disagreeing.
 */
export const LIST_SPECS: Record<DeclarationListKind, ListSpec> = {
  FUNDER: {
    kind: 'FUNDER',
    title: 'Other finance you use',
    // Legal's words, final (DOC-78-A §2, `LEG-006 §1`) — not ours to vary.
    lead:
      'List any other lender or funder your business has a facility with. ' +
      'This helps us read your bank statements correctly. ' +
      "We'll also ask you about other finance as part of your application.",
    addLabel: 'Add a funder',
    emptyText: 'No other funders listed yet.',
  },
  RELATED_PARTY: {
    kind: 'RELATED_PARTY',
    title: 'Related businesses and people',
    lead:
      'Businesses or people connected to yours — a holding company, a ' +
      'subsidiary, a business with a shared director, family.',
    addLabel: 'Add a related party',
    emptyText: 'No related parties listed yet.',
  },
  DIRECTOR: {
    kind: 'DIRECTOR',
    title: 'Directors and shareholders',
    lead: 'Everyone who is a director or a shareholder of this business.',
    addLabel: 'Add a director',
    emptyText: 'No directors or shareholders listed yet.',
  },
};
